"use strict";
exports.generateSendSmsData = ({ workspaceId, recipients, message, link, collectResponses, stepName, }) => ({
    workspaceId,
    recipients,
    message,
    link,
    collectResponses,
    stepName,
});
exports.generateSendWebformData = ({ workspaceId, recipients, message, link, stepName, }) => ({
    workspaceId,
    recipients,
    message,
    link,
    stepName,
});
//# sourceMappingURL=dataFactory.js.map